module.exports = __webpack_public_path__ + "img/lp-virus.95d280fb.svg";